import { render, staticRenderFns } from "./EmissionCard.vue?vue&type=template&id=2c1da68c&"
import script from "./EmissionCard.vue?vue&type=script&lang=js&"
export * from "./EmissionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports